import React from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { Icon } from "@/components/common/Icon";

export function Industries({ industries = [] }) {
  const { t } = useT();
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="industries-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          overline={t("industries.overline")}
          title={t("industries.title")}
          subtitle={t("industries.subtitle")}
          align="center"
        />
        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3">
          {industries.map((ind, i) => (
            <Reveal key={ind.name} delay={(i % 3) * 0.06}>
              <Link
                to="/industries"
                data-testid={`industry-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-teal hover:shadow-lg"
              >
                {ind.image && (
                  <div className="h-28 overflow-hidden">
                    <img src={ind.image} alt={ind.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                  </div>
                )}
                <div className="flex items-start gap-4 p-5">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-ink/5 text-ink transition-colors group-hover:bg-gradient-to-br group-hover:from-[#1E73BE] group-hover:to-[#16B894] group-hover:text-white">
                    <Icon name={ind.icon} size={22} weight="duotone" />
                  </div>
                  <div>
                    <p className="font-heading text-base font-semibold text-ink">{ind.name}</p>
                    <p className="mt-1 text-xs leading-relaxed text-slate-500">{ind.desc}</p>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
